/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

const DEFAULT_FORMAT = 'D MMMM YYYY, HH:mm';
const DEFAULT_OPTIONS = {
  alwaysJakartaTime: false
};
const SECONDS_IN_MINUTE = 60;
const TIMEZONE_SUFFIX = {
  7: 'WIB',
  8: 'WITA',
  9: 'WIT',
};

/**
 * Transform date into desired format with WIB, WITA or WIT suffix
 *
 * @param {String|Date|moment} date - Date to be transformed
 * @param {String} format - Desired format
 * @param {Boolean} options.alwaysJakartaTime - If true, timezone will always being set to GMT+7
 * @returns String
 */
export function localizeDate(date = null, format = DEFAULT_FORMAT, options = DEFAULT_OPTIONS) {
  if (!date) return date;

  const { alwaysJakartaTime } = options;
  if (alwaysJakartaTime) {
    return `${dayjs(date).utc().add(7, 'hours').format(format)} WIB`;
  }

  const timezoneHoursOffset = dayjs(date).utcOffset() / SECONDS_IN_MINUTE;
  const timezoneSuffix = TIMEZONE_SUFFIX[timezoneHoursOffset] || '';
  return `${dayjs(date).format(format)} ${timezoneSuffix}`;
}

/**
 * Transform date into desired format with location timezone
 *
 * @param {String|Date|moment} date - Date to be transformed
 * @param {String} format - Desired format
 * @param {Boolean} isBracketed - If true, timezone will be in bracket eg [Jakarta]
 * @returns String
 */
export function formatDateWithTimezone(date, format, isBracketed = false) {
  if (!date) return '';

  const time = dayjs(date);
  const localTimeZone = dayjs.tz.guess().split('/').at(1).replace('_', ' ');

  if (isBracketed) return `${time.format(format)} [${localTimeZone}]`;
  return `${time.format(format)} ${localTimeZone}`;
}
